import React from 'react';
import { Subtitle2 } from '../typography';
import { StyledOverlay } from './styled';
import { LoadingIndicator } from '../loading-indicator';
/**
 * @typedef LoadingOverlayProps
 * @type {Object}
 * @property {string} [text='Loading'] - Text to display alongside the loading indicator.
 */
const LoadingOverlay = ({ text = 'Loading', ...rest }) => {
    return (React.createElement(StyledOverlay, { ...rest, isHidden: false },
        React.createElement(LoadingIndicator, null),
        React.createElement(Subtitle2, null, text)));
};
export default LoadingOverlay;
